import { InfoRounded } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Typography } from '@mui/material';
import RenderElement from '../RenderElement';


interface ConfirmBoxProps {
    open: boolean;
    handleClose: () => void;
    handleOk: () => void;
    okText?: string;
    cancelText?: string;
    title?: string;
    contentText?: string;
    warningText?: string;
}

const ConfirmBox = (props: ConfirmBoxProps) => {
    const { open, title, handleClose, handleOk, okText, cancelText, contentText, warningText } = props;
  return (
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {contentText}
          </DialogContentText>
          <RenderElement show={!!warningText}>
            <Stack spacing={2} direction="row" alignItems="center" my={2} p={2} sx={{ background: '#f2f2f2' }}>
                <InfoRounded color="inherit" />
                <Typography variant="body2">{warningText}</Typography>
            </Stack>
          </RenderElement>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{cancelText || 'Disagree'}</Button>
          <Button onClick={handleOk} autoFocus>
            {okText || 'Agree'}
          </Button>
        </DialogActions>
    </Dialog>
  )
}

export default ConfirmBox;
